import React, { Component } from 'react';
import classnames from "classnames";
import { Translate } from 'react-localize-redux';
import { withRouter } from 'react-router';
import { NavLink } from 'react-router-dom';
import { connect } from "react-redux";
import { isNullOrUndefined } from '../../store/storeFunctions';
import { reportActions } from '../../store/reportStore';
import { searchActions } from '../../store/searchStore';
import { withLocalize } from "react-localize-redux";
import { bindActionCreators } from 'redux';

import MainHeader from './mainHeader';
import { PdfExportButton } from '../common/refButtons';

import './headersCommon.scss'

class MspSearchHeader extends Component {
    render() {
        const isOnSearchPage =  !isNullOrUndefined(this.props.location) ? this.endsWith(this.props.location.pathname, '/customizable-msp') : false;
        let entityId = !isNullOrUndefined(this.props.location) && !isNullOrUndefined(this.props.location.state) ? this.props.location.state.entityId : null;

        //FIX firefox problem with entityId from location state
        if (isNullOrUndefined(entityId)){
            let parts = this.props.location.pathname.split('/');
            entityId = parts[parts.length - 1];
        }

        return (<>
            <MainHeader label="LeftPanel.CustomizableMSPEvaluation" {...this.props} />
            {!this.props.isMobile && <div className={classnames('tabs tabs-subheader shadowed', { 'tinted': this.props.tinted })}>
                <ul style={{ border: "none" }}>
                    <li className={`tab-link ${isOnSearchPage ? 'is-active' : ''}`}>
                        <NavLink to={`${this.props.match.url}`} >
                            <Translate id='Search.Common.SubjectSearch' />
                        </NavLink>
                        <div className="search-progress-short" style={{ display: isOnSearchPage ? "" : "none" }}></div>
                    </li>

                    {this.isOnResultsPage() &&
                        <li className={`tab-link ${this.isOnResultsPage() ? 'is-active' : ''}`}>
                            <NavLink to={`${this.props.match.url}/branch`}>
                                <Translate id='Search.Common.Requests' />
                            </NavLink>
                            <div className="search-progress-short" style={{ display: this.isOnResultsPage() ? "" : "none" }}></div>
                        </li>}
                </ul>
                {!isNullOrUndefined(entityId) && <div className='search-pdf-export'>
                    <div className='references print-hidden'>
                        <div className="ref-buttons" style={{ display: 'flex' }}>
                            <PdfExportButton onClick={() => this.props.exportPdf(entityId)} isEnabled={true} disabledKey='Common.Button.ExportPdf.Processing' withDelayAfterFirstToggle />
                        </div>
                    </div>
                </div>}
            </div>}
        </>)
    }

    isOnResultsPage = () => this.isActiveLink('/report');
    isActiveLink = (item) => this.props.location.pathname.indexOf(item) >= 0;
    endsWith = (str, suffix) => isNullOrUndefined(str) || isNullOrUndefined(suffix) ? false : str.lastIndexOf(suffix, str.length - suffix.length) === str.length - suffix.length;
}

export default withLocalize(withRouter(connect(
    state => ({ ...state, search: state.search, layout: state.layout, report: state.report}),
    dispatch => bindActionCreators({ ...searchActions, ...reportActions }, dispatch)
)(MspSearchHeader)));

